import {Frame} from "../z40-uicomp/frame";
import {HelpContent} from "../z70-shadcn/components/HelpContent";




export function Help() {

   
    return (
        <Frame>
            <div className="lyw-container min-h-screen bg-gradient-to-br from-white to-slate-50 py-16 px-6 sm:px-12 lg:px-24">
                <div className="max-w-4xl mx-auto">
                    {/* Header Section */}
                    <div className="text-center mb-12">
                        <h1 className="text-5xl md:text-6xl font-extrabold text-[#1c5375] mb-6">Get in touch with us.</h1>
                        <p className="text-[#656565] text-xl md:text-2xl max-w-3xl mx-auto leading-relaxed">
                            We're here to help with any questions or support you need.
                        </p>
                    </div>
                    <HelpContent/>
                </div>
            </div>
        </Frame>
    );
}